import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DeleteTemplateModal } from '../templates/delete-template-modal.component';
import { TemplatesService } from '../templates/templates.service';
import { AuthServiceService } from 'src/app/services/auth-service.service';

@Component({
  selector: 'app-proposal-templates',
  templateUrl: './proposal-templates.component.html',
  styleUrls: ['./proposal-templates.component.css']
})
export class ProposalTemplatesComponent implements OnInit {

  constructor(private _templateService: TemplatesService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef, private auth:AuthServiceService) { }

  //todo: make it dynamic
  categoryId = 3;//proposal categoryId
  currentDocuments: any = [];
  selectedDocsForDownload = [];
  canDownload = false;
  public loading = false;
  from = 0
  size = 12
  ngOnInit() {
    this.getDocuments(this.from,this.size);
  }
  getDocuments(from:number,size:number) {
    this.cd.detectChanges();
    this._templateService.getAllTemplatesById(this.categoryId,from,size).subscribe(res => {
      this.currentDocuments = res.data.sort((a, b) => a.name.localeCompare(b.name));
      if (this.canDownload) {
        this.selectedDocsForDownload = this.currentDocuments;
      }
      this.cd.detectChanges();
      this.loading = false;
    }, error => {
      this.loading = false;
    });
  }
  selectAllForDownload(event) {
    this.canDownload = event.target.checked;
    this.selectedDocsForDownload = this.canDownload ? this.currentDocuments : [];

  }
  isSelected(doc) {
    return this.selectedDocsForDownload.indexOf(doc) > -1 ? true : false
  }
  selectForDownload(event, data) {
    if (event.target.checked)
      this.selectedDocsForDownload.push(data)
    else
      this.selectedDocsForDownload = this.selectedDocsForDownload.filter(sd => sd.id != data.id);
    this.canDownload = this.currentDocuments.length == this.selectedDocsForDownload.length ? true : false;
  }
  downloadAllTemplate() {
    this.loading = true;
    let templateIds = this.selectedDocsForDownload.map(i => i.id);
    this._templateService.downloadAllTemplate(templateIds).subscribe(data => {
      let resultData = data.data;
      for (let i = 0; i < resultData.length; i++) {
        var a = document.createElement("a");
        a.href = 'data:' + resultData[i].mimeType + 'base64,' + resultData[i].fileBase64;
        a.download = resultData[i].name; //File name Here
        a.click();
        a.remove();
      }
      setTimeout(() => this.getDocuments(this.from,this.size), 1000);
    });
  }
  downloadTemplate(uuid,sharepointId,name) {
    this.loading = true;
    this._templateService.downloadTemplate(uuid,sharepointId).subscribe(res => {
      var url = res.message
      let a = document.createElement("a");
      document.body.appendChild(a);
      a.href = url;
      a.download = String(name);
      a.click();
      a.remove();
      this.toastr.success("Template downloaded successfully")
      setTimeout(() => this.getDocuments(this.from,this.size), 1000);
    })
  }
  openDeleteTemplate(data) {

    if (data) {
      //this.selectedDocsForDownload = [];
      data = [data];
    }
    else {
      data = this.currentDocuments;
    }
    const dialogRef = this.dialog.open(DeleteTemplateModal, {
      width: '450px',
      height: '200px',
      //panelClass: 'view-file',
      data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loading = true;
        this.cd.detectChanges();
        setTimeout(() => this.getDocuments(this.from,this.size), 1000);
      }
    });

  }
  isAuthorizedUser(data)
  {
    var roles = this.auth.getRole();
    if(roles.indexOf('SuperAdmin')>=0 || roles.indexOf('Proposal.Admin')>=0)
      return true
    else{
      if(roles.indexOf('Proposal.User') >=0)
      {
        if(data.createdById.toString() == this.auth.getEmployeeId())
          return true;
      }
    }
    return false;
  }
}